module.exports = __webpack_public_path__ + "static/media/VIP_Background@3x.adc42b28.jpg";